<template>
  <div>
    <v-card class="mb-5">
      <!-- Au moins une phrase ou une sous-bibliothèque -->
      <v-list two-line dense v-if="biblio.sentences.length || biblio.subs.length">
        <v-subheader>
          {{ $tc('subLibraries', biblio.subs.length, { count: biblio.subs.length }) }}
        </v-subheader>
        <!-- sous-bibliothèques -->
        <template v-for="(sub, i) in biblio.subs">
          <wz-biblio :biblio.sync="sub" @update="updateBiblio()" :key="i"></wz-biblio>
        </template>
        <!-- loader pour l'ajout d'une sous-bibliothèque -->
        <v-list-tile v-if="loadingSub" class="text-xs-center">
          <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
        </v-list-tile>
        <v-divider v-if="biblio.sentences.length && biblio.subs.length" inset></v-divider>
        <v-subheader>
          {{ $tc('sentences', biblio.sentences.length, { count: biblio.sentences.length }) }}
        </v-subheader>
        <!-- phrases -->
        <template v-for="(sentence, i) in biblio.sentences">
          <wz-sentence
            :sentence="sentence"
            :biblio.sync="biblio"
            :key="i"
          ></wz-sentence>
        </template>
        <!-- loader pour l'ajout d'une phrase -->
        <v-list-tile v-if="loadingSentence" class="text-xs-center">
          <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
        </v-list-tile>
      </v-list>

      <!-- Aucune phrase -->
      <v-container v-else fluid grid-list-lg>
        <v-layout row>
          <v-flex xs3>
             <v-img
                src="https://www.gstatic.com/mobilesdk/160505_mobilesdk/zerostate/2x/database.png"
                height="125px"
                contain
              ></v-img>
          </v-flex>
          <v-flex xs7>
            <div class="headline">{{$t('noSentence')}} : {{ biblio.title }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-speed-dial
      v-model="fab"
      bottom
      floating
      fixed
      right
    >
      <v-btn
        slot="activator"
        fab
        dark
        v-model="fab"
        color="secondary"
      >
        <v-icon>add</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-tooltip left>
        <v-btn
          fab
          dark
          small
          color="primary"
          class="white--text"
          slot="activator"
          @click.native.stop="openDialogCreateSentence"
        >
          <v-icon>short_text</v-icon>
        </v-btn>
        <span>{{ $t('add') + ' ' + $tc('sentences', 1) | cap }}</span>
      </v-tooltip>
      <v-tooltip left>
        <v-btn
          fab
          dark
          small
          color="primary"
          class="white--text"
          slot="activator"
          @click.native.stop="openDialogCreateSub"
        >
          <v-icon>book</v-icon>
        </v-btn>
        <span>{{ $t('add') + ' ' + $tc('subLibraries', 1) | cap }}</span>
      </v-tooltip>
    </v-speed-dial>

    <!-- DIALOGUE CREATION PHRASE-->
    <v-dialog v-model="showDialogCreateSentence" max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('add') + ' ' + $tc('sentences', 1) | cap }}</v-card-title>
        <v-divider></v-divider>
          <v-card-text>
            <v-textarea
              autofocus
              :label="$t('title')" 
              v-model="sentenceDialog.title"
              counter="256"
              required
              v-validate="'required|max:256'" 
              data-vv-name="sentenceInput"
              :error="wzErrors.has('sentenceInput')"
              :error-messages="wzErrors.collect('sentenceInput')"
              @keyup.native.enter="submitDialogCreateSentence" 
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDialogCreateSentence = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :disabled="wzErrors.any()" @click.native="submitDialogCreateSentence">{{ $t('submit') }}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGUE CREATION SOUS-BIBLIO-->
    <v-dialog v-model="showDialogCreateSub" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('add') + ' ' + $tc('subLibraries', 1) | cap }}</v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            :label="$t('title')" 
            v-model="subDialog.title"
            counter 
            max="32" 
            required
            v-validate="'required|max:32'" 
            data-vv-name="subInput"
            :error="wzErrors.has('subInput')"
            :error-messages="wzErrors.collect('subInput')"
            @keyup.native.enter="submitDialogCreateSub" 
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDialogCreateSub = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" @click.native="submitDialogCreateSub">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: ['id'],

  data () {
    return {
      /**
       * bibliothèque gérée par la vue
       * @type {Object}
       */
      biblio: null,
      /**
       * phrase gérée dans le dialogue
       * @type {Object}
       */
      sentenceDialog: null,
      /**
       * indique si le dialog de création d'une phrase est affiché
       * @type {Boolean}
       */
      showDialogCreateSentence: false,
      loadingSentence: false,

      /**
       * sous-biblio gérée dans le dialogue
       * @type {Object}
       */
      subDialog: null,
      /**
       * indique si le dialog de création d'une sous-biblio est affiché
       * @type {Boolean}
       */
      showDialogCreateSub: false,
      loadingSub: false,

      fab: false
    }
  },

  created () {
    this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.id)
    if (_.isNil(this.biblio)) {
      this.$router.go(-1)
    }
    this.sentenceDialog = this.newSentence()
    this.subDialog = this.newSub()
    this.$store.commit('_Toolbar/SET_SUB_TITLE', this.biblio.title)
  },

  methods: {
    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle phrase à créer
     */
    openDialogCreateSentence () {
      this.$validator.reset()
      this.sentenceDialog = this.newSentence()
      this.showDialogCreateSentence = true
    },
    /**
     * valide la nouvelle phrase à créer
     */
    submitDialogCreateSentence () {
      this.showDialogCreateSentence = false
      if (_.isEmpty(this.sentenceDialog.title)) {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Titre vide', context: 'warning' })
        return
      }
      // recherche de la phrase dans la liste des phrases
      // si elle n'est pas trouvée alors on peut la créer
      let sentenceFound = _.find(this.biblio.sentences, ['title', this.sentenceDialog.title])
      if (_.isNil(sentenceFound)) {
        this.loadingSentence = true
        // création côté serveur en BDD
        let dataToPost = new window.FormData()
        dataToPost.append('SEN_MSG', this.sentenceDialog.title)
        dataToPost.append('SEN_FAM_ID', this.biblio.id)
        dataToPost.append('ENT_ID', this.$store.state._User.entId)

        this.axios.post('post/sentence.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          // les changements été pris en compte :
          // - attribution d'un id pour la biblio qui vient d'être créée
          this.sentenceDialog.id = response.data.id
          let biblioUpdate = _.cloneDeep(this.biblio)
          biblioUpdate.sentences.push(this.sentenceDialog)
          this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate)
          this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.id)
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
        })
        .catch(_ => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
        })
        .then(_ => {
          this.loadingSentence = false
        })
      } else {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' })
      }
    },
    newSentence () {
      return {
        id: '',
        title: ''
      }
    },

    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle sous-biblio à créer
     */
    openDialogCreateSub () {
      this.$validator.reset()
      this.subDialog = this.newSub()
      this.showDialogCreateSub = true
    },
    /**
     * valide la nouvelle sous-biblio à créer
     */
    submitDialogCreateSub () {
      this.showDialogCreateSub = false
      if (_.isEmpty(this.subDialog.title)) {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('cantCreate'), context: 'warning' })
        return
      }
      // recherche de la biblio dans la liste des biblios
      // si elle n'est pas trouvée alors on peut la créer
      let biblioFound = this.$store.getters['_Biblios/GET_BIBLIO_BY_TITLE'](this.subDialog.title)
      if (_.isNil(biblioFound)) {
        // création côté serveur en BDD
        let dataToPost = new window.FormData()
        dataToPost.append('FAM_NAME', this.subDialog.title)
        dataToPost.append('FAM_IS_SUBFAMILY', this.biblio.id)
        this.axios.post('post/biblio.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          // les changements été pris en compte :
          // - attribution d'un id pour la biblio qui vient d'être créée
          this.subDialog.id = response.data.id
          this.subDialog.title = this.subDialog.title
          this.subDialog.sub = this.biblio.id
          this.$store.commit('_Biblios/ADD_BIBLIO', this.subDialog)
          this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.id)
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
        })
        .catch(_ => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
        })
        .then(_ => {
          this.loading = false
        })
      } else {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' })
      }
    },
    newSub () {
      return {
        id: '',
        title: '',
        sentences: []
      }
    },

    updateBiblio () {
      this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.id)
    }
  },

  /**
   * fonction executée avant de quitter la vue
   * @param  {route}   to   prochaine route
   * @param  {route}   from route actuelle
   * @param  {Function} next fonction permettant d'aller à la prochaine route
   */
  beforeRouteUpdate (to, from, next) {
    // si le paramètres de la prochaine route ne correspond pas à une biblio existante
    // pas de changement de route
    this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](to.params.id)
    if (!_.isNil(this.biblio)) {
      to.params.id = this.id
      this.$store.commit('_Toolbar/SET_SUB_TITLE', this.biblio.title)
      next()
    } else {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/Biblio.vue